import styles from './ProjectCarousel.module.css'
import logo from '../../assets/les-logo.png'
import Card from '../ImageCard/ImageCard';
import CustomSlider from '../CustomSlider/CustomSlider';

export default function ProjectCarousel() {
    const elements = Array.from({ length: 100 }, (v, k) => <Card key={k} imageUrl={logo} seeMore="Ver Mais" title='Título do Projeto' description='Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tincidunt ultricies nec lacus luctus faucibus. Morbi morbiadipiscing elit.' />)
    
    return (
        <CustomSlider elements={elements}/>
    );
}